import React from 'react'
import "./Everest-Heli.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarCheck,faPhotoFilm,faSliders,faBolt,faCheck,faStar,faXmark, faDownload, faMinus, faPlus, faTag,faEnvelope ,faCalendarDays, faCloud, faGaugeHigh, faArrowRight,faBus, faMapLocationDot, faHotel, faMessage, faSquareArrowUpRight,faChevronDown, faMicrophone,faChevronUp, faBowlFood, faMountain} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp,faWeixin,} from '@fortawesome/free-brands-svg-icons'
import { useState } from 'react'
import {useEffect}from 'react'
import PackageSlider from "./Component/PackageSlider";
import Bookingform from "./Component/bookingform";
import Enquiryform from "./Component/enquiryform";
import Review from "./Component/review";
import TourNav from './Component/stickynav';
const packages = [
  {
    title: "7 Unesco Heritage Tour",
    days: "8 Hours",
    duration: "8-9 Hours",
    difficulty: "Easy",
    price: 190,
    image: "/img/capital/pasupatinath.jpg",
    link: "/one-day-nepal-7unescoheritage-tour"
  },
  {
    title: "Nepal Golden Triangle Tour",
    location: "Nepal",
    days: "8 Days",
    difficulty: "Easy",
    price: 940,
    duration: "8 Days",
    image: "/img/chitwan/chitwan3dslr.jpeg",
    link: "/kathmandu-chitwan-pokhara-8days-nepaltour"
  },
  {
    title: "Peak & Safaris",
    location: "Nepal",
    days: "6 Days",
    difficulty: "Easy",
    price: 1150,
    duration: "6 Days",
    image: "/img/capital/nagarkot.webp",
    link: "/kathmandu-chitwan-nagarkot"
  },
  {
    title: "Nature Majestic Loop",
    location: "Nepal",
    days: "10 Days",
    difficulty: "Easy",
    price: 2350,
    duration: "10 Days",
    image: "/img/treek/Dhampus.webp",
    link: "/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour"
  }
];
const images = [
  "/img/company/airportdslr.jpeg",
  "/img/company/me1dslr.jpeg",
  "/img/mounteve/moun1.webp",
  "/img/capital/myself.jpg",
  "/img/mounteve/Heli.webp",
  "/img/mounteve/moun2.webp",
  "/img/company/groupphoto.jpeg",
  "/img/capital/Nagarkot.avif",
  "/img/capital/pro.png",
  "/img/company/mewith.jpeg",
  "/img/capital/bouddha.webp",
  "/img/capital/pashupatinath.jpg",
  "/img/capital/pasupatinath.jpg",
  "/img/capital/image-asset.webp",
  "/img/company/medslr.jpeg",
];
const Senioreve = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [count,Setcount]=useState(1);
  const [day1Open, setDay1Open] = useState(false);
  const [day2Open, setDay2Open] = useState(false);
  const [day3Open, setDay3Open] = useState(false);
  const [day4Open, setDay4Open] = useState(false);
  const [day5Open, setDay5Open] = useState(false);
  const [day6Open, setDay6Open] = useState(false);
  const next = () => {
    setIndex((index + 1) % images.length);
  };

  const prev = () => {
    setIndex((index - 1 + images.length) % images.length);
  };
  const getmul=(qty)=>{
    if(qty===1)return 5850;
if(qty>=2 && qty<=3)return 5600;
if(qty>=4 && qty<=7)return 5600;
if(qty>=8 && qty<=19)return 5600;
if(qty>=20)return 5600;
    };
    const totalprice =count*getmul(count);
    const [opent, seT] = useState(false);
    const [opente, seTe] = useState(false);
    const [openr, seTr] = useState(false);
    const [openH, seTh] = useState(false);
    useEffect(()=>{
      if(opent){
        document.body.style.overflow='hidden';
      }
      else{
        document.body.style.overflow='unset';
      }
      return()=>{
        document.body.style.overflow='unset';
      }
    },[opent]);
    useEffect(()=>{
      if(openH){
        document.body.style.overflow='hidden';
      }
      else{
        document.body.style.overflow='unset';
      }
      return()=>{
        document.body.style.overflow='unset';
      }
    },[openH]);
    const [activeIndex, setActiveIndex] = useState(null);
    
      const toggleFaq = (index) => {
        if (activeIndex === index) {
          setActiveIndex(null);
        } else {
          setActiveIndex(index);
        }
      };
  return (
   <main>
 <TourNav />
    <div className='main'>
    <div className='Left'>
    <h1 className="tourTitle">Everest Without Treeking For Seniors</h1>

    <div className="breadcrumb">
    Kathmandu-Nagarkot-Mount Everest <span>6 Days Tour</span>
    </div>
     <div className="everest-image">
        <div className="everest-full">
          <img src="/img/mounteve/mountain.jpg" alt="error" />
          <div
      className="tourgps"
      onClick={() => setOpen(true)}
    >  <FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon> View Gallery
       </div>  
        </div>
        <div className="everest-half">
            <div className="image-box"> <img src="/img/mounteve/Heli.webp" alt="error" /></div>
            <div className="image-box"> <video src="/video/videodslr.mp4" controls autoPlay muted loop></video></div>
        </div>
     </div>
     {open && (
  <div className="roomModal tourgr">
    <div className="roomModal__content">

      <div
        className="roomModal__close"
        onClick={() => setOpen(false)}
      >
        ✕
      </div>

      <img
        src={images[index]}
        alt="big"
        className="roomModal__image"
      />

      <div
        className="roomModal__nav roomModal__nav--left"
        onClick={prev}
      >
        ❮
      </div>

      <div
        className="roomModal__nav roomModal__nav--right"
        onClick={next}
      >
         ❯  
      </div>

      <div className="roomModal__thumbs">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="thumb"
            className={
              index === i
                ? "roomModal__thumb active"
                : "roomModal__thumb"
            }
            onClick={() => setIndex(i)}
          />
        ))}
      </div>

    </div>
  </div>
)}
    <div className="Trip-fact">
      <h3>Trip Facts</h3>
      <div className="grid">
        <div className="grid-item">
          <FontAwesomeIcon icon={faCalendarDays}/>
          <div className="grid-item-next">
            <p className='Dur'>Duration</p>
            <p className='Duration'>6 Days</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faCloud}/>
          <div className="grid-item-next">
            <p className='Dur'>Best Time</p>
            <p className='Duration'>Sept - May</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faGaugeHigh}/>
          <div className="grid-item-next">
            <p className='Dur'>Grade</p>
            <p className='Duration'>Easy / Senior Friendly</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faBus}/>
          <div className="grid-item-next">
            <p className='Dur'>Transportation</p>
            <p className='Duration'>Private Luxury Vehicle & Heli</p>
          </div>
        </div>
 
        <div className="grid-item">
          <FontAwesomeIcon icon={faMapLocationDot}/>
          <div className="grid-item-next">
            <p className='Dur'>Type Of Tour</p>
            <p className='Duration'>Aerial Everest & Cultural Wellness</p>
          </div>
        </div>

         <div className="grid-item">
          <FontAwesomeIcon icon={faHotel}/>
          <div className="grid-item-next">
            <p className='Dur'>Hotel Included</p>
            <p className='Duration'>5 Star Luxury Resorts</p>
          </div>
        </div>
        <div className="grid-item">
          <FontAwesomeIcon icon={faBowlFood}/>
          <div className="grid-item-next">
            <p className='Dur'>Breakfast</p>
            <p className='Duration'>Included (Gourmet)</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faMountain}/>
          <div className="grid-item-next">
            <p className='Dur'>Max Elevation</p>
            <p className='Duration'>5,545 M (Aerial) / 2,175 M (Stay)</p>
          </div>
        </div>

      </div>

       </div>
       <div className="overview-container"id='overview'>
  <div className="heading">Highlights Of Tours</div>
  <div className="flex-p">
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Witness Mount Everest face-to-face with a 1-hour Mountain Flight and a private Helicopter excursion.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Luxury comfort designed specifically for seniors with minimal walking and private transfers.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Deep relaxation with authentic Himalayan Singing Bowl Sound Therapy and Ayurvedic Spa sessions.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Exclusive sunset and sunrise views over the Langtang and Everest ranges from Nagarkot.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Explore the medieval "City of Devotees," Bhaktapur, a living museum of Newari culture.</p>
  </div>
</div>
       <div className="overview-container">
  <div className="overview-heading">Overview</div>

  <div className="overview-text">
  Designed for the discerning traveler, our **Everest Horizon & Himalayan Wellness Tour** offers a majestic encounter with the world's highest peaks without the physical strain of trekking. This 6-day curated experience balances high-altitude thrills via luxury aircraft and helicopters with grounded spiritual rejuvenation through ancient Ayurvedic practices. From the royal courtyards of Kathmandu to the cloud-level vistas of Nagarkot, every detail is refined for senior comfort, safety, and cultural immersion.
  </div>
  <div className="heading smalling">Places You’ll Visit:</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Kathmandu Durbar Square:</b> A royal complex showcasing centuries of wood-carved artistry.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Boudhanath & Swayambhunath:</b> Nepal's most iconic spiritual landmarks for peace and perspective.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Everest Region (Aerial):</b> Close-up views of Lhotse, Nuptse, and Everest via private Helicopter.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Bhaktapur Durbar Square:</b> A UNESCO site famed for its 55-window palace and golden gates.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Nagarkot:</b> The premier hill station for a panoramic sweep of the central Himalayas.</p>
  </div>

  <div className="heading smalling">Introduction Of Experiences</div>
 <p className='overview-text'><b>The Himalayan Flight:</b> Start your morning above the clouds. This 1-hour flight provides a window seat to the roof of the world, offering a safe and awe-inspiring view of the highest peaks on Earth.</p>
<p className='overview-text'><b>Himalayan Singing Bowl Therapy:</b> Experience ancient sound healing. The vibrations of the hand-beaten bowls help align your energy, reduce travel fatigue, and provide a deep sense of mental clarity—a perfect treat for the senior traveler.</p>
<p className='overview-text'><b>The Helicopter Excursion:</b> A 3 to 4-hour journey that takes you deep into the heart of the Khumbu region. Landing at a high-altitude viewpoint, you will breathe the crisp mountain air and stand in the shadow of giants like Everest and Ama Dablam.</p>
<p className='overview-text'><b>Ayurvedic Rejuvenation:</b> After days of sightseeing, indulge in a traditional Ayurvedic spa. Using Himalayan herbs and oils, this session is designed to soothe joints and promote longevity, rooted in 5,000 years of Vedic wisdom.</p>
</div>

<div className="overview-container">
  <div className="overview-heading">Why This Package?</div>
 <div className="heading smalling">Tailored for Senior Comfort</div>
 <p className='overview-text'>We prioritize ease of access. All destinations are reached via luxury private vehicles with minimal walking. Our itineraries are "slow-paced," ensuring you never feel rushed.</p>
 <div className="heading smalling">The Everest Dual-Experience</div>
 <p className='overview-text'>Most tours offer just one view. We provide two: a fixed-wing mountain flight for the scale, and a helicopter landing for the intimacy of the Khumbu region.</p>
 <div className="heading smalling">Wellness Integration</div>
 <p className='overview-text'>This isn't just a tour; it’s a retreat. By including Singing Bowl therapy and Ayurvedic massage, we ensure you return home physically refreshed and spiritually uplifted.</p>
</div>

<div className="overview-container">
  <div className="overview-heading"id='itinerary'>ITINERARY</div>
  
  {/* Day 1 */}
  <div className="timeline-row">
        <div className="timeline-left">
          <div className="day-circle">Day 1</div>
        </div>
        <div className="timeline-right" onClick={() => setDay1Open(!day1Open)}>
          <div className="timeline-title">Arrival & Kathmandu Heritage</div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day1Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
      </div>
      {day1Open && (
        <div className="timeline-detail">
         Upon arrival at Tribhuvan International Airport, receive a traditional Khada welcome. After a smooth hotel check-in, enjoy a private afternoon tour of Kathmandu Durbar Square to witness the living history of the Malla kings and the Living Goddess Kumari.
        </div>
      )}

{/* Day 2 */}
<div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 2</div>
        </div>
        <div className="timeline-right" onClick={() => setDay2Open(!day2Open)}> 
          <div className="timeline-title">Mountain Flight & Spiritual Circles</div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day2Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
</div>
{day2Open && (
        <div className="timeline-detail">
        Early morning 1-hour Mountain Flight for Everest views. Return for breakfast, then visit the peaceful Boudhanath Stupa and the hilltop "Monkey Temple," Swayambhunath. The day focuses on spiritual serenity and panoramic valley views.
        </div>
      )}

{/* Day 3 */}
<div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 3</div>
        </div>
        <div className="timeline-right" onClick={() => setDay3Open(!day3Open)}> 
          <div className="timeline-title">Everest Helicopter Excursion</div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day3Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
</div>
{day3Open && (
        <div className="timeline-detail">
        A 3-4 hour private Helicopter tour into the Everest region. Witness the Khumbu Icefall and land at a premium viewpoint (Syangboche or Kalapatthar, weather permitting) for a once-in-a-lifetime photo opportunity before flying back to Kathmandu.
        </div>
      )}

{/* Day 4 */}
<div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 4</div>
        </div>
        <div className="timeline-right" onClick={() => setDay4Open(!day4Open)}> 
          <div className="timeline-title">Bhaktapur Artistry & Nagarkot Sunset</div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day4Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
</div>
{day4Open && (
        <div className="timeline-detail">
        Drive to the ancient city of Bhaktapur. Explore its car-free streets and pottery squares. Continue the drive to the Nagarkot hill station. Check into your luxury resort and enjoy a sunset toast overlooking the Himalayan range.
        </div>
      )}

{/* Day 5 */}
<div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 5</div>
        </div>
        <div className="timeline-right" onClick={() => setDay5Open(!day5Open)}> 
          <div className="timeline-title">Himalayan Wellness & Spa Therapy</div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day5Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
</div>
{day5Open && (
        <div className="timeline-detail">
        After a Nagarkot sunrise, return to Kathmandu. The afternoon is dedicated to your well-being. Experience a 60-minute Himalayan Singing Bowl Sound Healing session followed by a customized Ayurvedic Spa or traditional massage to rejuvenate your body.
        </div>
      )}

{/* Day 6 */}
<div className="timeline-row time-linemargin">
        <div className="timeline-left">
          <div className="day-circle">Day 6</div>
        </div>
        <div className="timeline-right" onClick={() => setDay6Open(!day6Open)}> 
          <div className="timeline-title">Souvenirs & Departure</div>
          <div className="arrow-icon">
            <FontAwesomeIcon icon={day6Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
</div>
{day6Open && (
        <div className="timeline-detail">
        Enjoy a leisurely breakfast. If time permits, engage in last-minute shopping for local crafts in Thamel. Our private vehicle will then transfer you to the airport for your flight back home, carrying the peace of the mountains with you.
        </div>
      )}
</div>

<div className="overview-container width-hund"id='included'>
<div className="cost-box included">
        <div className="cost-title">Cost Included</div>
        <div className="cost-item">
          <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
          <div className="cost-text">1-Hour Everest Mountain Flight and 3-4 Hour Private/Group Heli Tour.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
          <div className="cost-text">English,Hindi or Chinese Speaking Professional National Guide.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
          <div className="cost-text">Luxury 5-Star accommodation in Kathmandu and Boutique Resort in Nagarkot.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
          <div className="cost-text">Complimentary Himalayan Singing Bowl Therapy & Ayurvedic Spa Session.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
          <div className="cost-text">Private AC Luxury Vehicle for all transfers and sightseeing.</div>
        </div>
      </div>

      <div className="cost-box excluded">
        <div className="cost-title">Cost Not Included</div>
        <div className="cost-item">
          <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
          <div className="cost-text">International Airfare and Visa Fees.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
          <div className="cost-text">Lunch and Dinner (Except Farewell Dinner).</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
          <div className="cost-text">Personal tips and alcoholic beverages.</div>
        </div>
      </div>
</div>
<div className="overview-container">
  <div className="heading vbn"><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon> FAQS
  </div>
  <section className="faq">
      <div className="faq-container">

        <div className="faq-list">
          <div className="faq-item" onClick={() => toggleFaq(0)}>
            <div className="faq-question">
            Booking & Payment Terms
              <span>{activeIndex === 0 ? "-" : "+"}</span>
            </div>
            {activeIndex === 0 && (
              <div className="faq-answer">
               To confirm your trip, a 10% deposit is required at the time of booking. Upon your arrival in Nepal and transfer to your hotel, 70% of the total fee is due to begin the tour services. The remaining balance payment must be settled in full after the fourth day of your journey.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(1)}>
            <div className="faq-question">
              How can I book a tour?
              <span>{activeIndex === 1 ? "-" : "+"}</span>
            </div>
            {activeIndex === 1 && (
              <div className="faq-answer">
                You can book directly from our website by clicking button  or contact our support team from right side contact details or from contact us page where is a QR for your ease scan and contactus.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(2)}>
            <div className="faq-question">
              Is This Package Suitable For Me ?
              <span>{activeIndex === 2 ? "-" : "+"}</span>
            </div>
            {activeIndex === 2 && (
              <div className="faq-answer">
            This package is perfectly suited for first-time travelers and families looking for a comprehensive introduction to Nepal without the physical demands of high-altitude trekking. It balances the deep historical roots of the Kathmandu Valley’s ancient squares with the tranquil, natural beauty of Pokhara’s lakeside and caves. Because every destination is accessible by vehicle, it is an excellent choice for senior citizens, photographers, or time-constrained tourists who want to experience the "Golden Triangle" of Nepal’s heritage and Himalayan views in comfort and style.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(3)}>
            <div className="faq-question">
              Can I cancel my booking and refund policies?
              <span>{activeIndex === 3 ? "-" : "+"}</span>
            </div>
            {activeIndex === 3 && (
              <div className="faq-answer">
                Yes you can cancel. we understand life will not run according to our plan. There is refund policies Cancel up to 6 days before in advance for a full refund after 6 days there will no refund of your 10% payment.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(4)}>
            <div className="faq-question">
              Preparation For This package
              <span>{activeIndex === 4 ? "-" : "+"}</span>
            </div>
            {activeIndex === 4 && (
              <div className="faq-answer">
                 <div className="heading smalling">What to Bring:</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Travel Documents:</b> Ensure you have a valid passport and printed copies of your booking confirmation and insurance.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Comfortable Footwear:</b> Pack a pair of sturdy walking shoes or sneakers for navigating the stone pathways of Bhaktapur and the nature trails in Sarangkot.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Seasonal Layering:</b> Bring a warm jacket or fleece for the early morning sunrises in Nagarkot and Sarangkot, as temperatures drop significantly before dawn.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Personal Care:</b> Remember to pack sunscreen, sunglasses, and a hat to protect yourself from the strong high-altitude sun during your Phewa Lake boat ride.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Day Pack:</b> Use a small backpack to keep your camera, power bank, and rain gear handy for sudden mountain weather changes.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Currency & Cash:</b> Keep some local currency (NPR) for personal expenses, tips, and meals not included in the package.</p>
  </div>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(5)}>
            <div className="faq-question">
              What about meal in this package?
              <span>{activeIndex === 5 ? "-" : "+"}</span>
            </div>
            {activeIndex === 5 && (
              <div className="faq-answer">
               <div className="heading smalling">Meal Plan Details</div>

<p className='overview-text'><b>Standard Inclusion:</b> Every morning begins with a fresh, delicious breakfast included at your hotel to fuel your day of exploration. This ensures you start your journey energized and ready for the sights ahead.</p>

<p className='overview-text'><b>Lunch & Dinner (Flexible):</b> To give you complete freedom over your palate, these meals are not included in the base price. Your guide will introduce you to top-rated local restaurants where you can pay directly, allowing you to discover the diverse flavors of Nepal at your own pace.</p>

<p className='overview-text'><b>Full-Board Upgrade (Recommended):</b> For those seeking a truly seamless and worry-free adventure, we can include all lunch and dinner charges in your package. We will handle all the arrangements and payments at every destination, so your only responsibility is to sit back, relax, and enjoy the trip.</p>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(6)}>
            <div className="faq-question">
              Do you provide customized tours?
              <span>{activeIndex === 6 ? "-" : "+"}</span>
            </div>
            {activeIndex === 6 && (
              <div className="faq-answer">
                Yes, we offer fully customizable travel experiences you can see button of customize below just click it and our travel expert will contact you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(7)}>
            <div className="faq-question">
              What Language are available for this package?
              <span>{activeIndex === 7 ? "-" : "+"}</span>
            </div>
            {activeIndex === 7 && (
              <div className="faq-answer">
                Our guides speak English, Hindi, and Chinese.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(8)}>
            <div className="faq-question">
              Do you offer group discounts?
              <span>{activeIndex === 8 ? "-" : "+"}</span>
            </div>
            {activeIndex === 8 && (
              <div className="faq-answer">
                When you see right side in desktop and little bit below in mobile screen we made a system where total price is calculated according to number of people and there may be available of more discount for group which is not mention in this system than our booking team will mention it while enquiry or booking.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(9)}>
            <div className="faq-question">
              How can I contact support?
              <span>{activeIndex === 9 ? "-" : "+"}</span>
            </div>
            {activeIndex === 9 && (
              <div className="faq-answer">
                You can reach us via email, phone and many more just see our contact us page.
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  </div>
<div className="overview-container">
  <div className="heading">Why Choose Us ?</div>

  <div className="flex-p">
   <p>1. From past 7 years we are continuously providing great service to our customer.</p>
   <p>2. After Booking with us your task is only to enjoy your trip.</p>
   <p>3. You can customize your holiday with our Destination expert.</p>
   <p>4. Providing better quality in compitative price is our main goal.</p>
   <p>5. Until your depature to your own country all responsibility like security is our duty.</p>
  </div>
</div>
<div className="overview-container width-hund">
<div className="review-section">

<div className="review-heading">
  What Our Travelers Say
</div>

<div className="review-wrapper">

  {/* REVIEW 1 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      The Everest Heli Tour was a dream come true. The views were unreal and
      the helicopter experience was smooth and luxurious.
    </div>

    <div className="review-user">
      <div className="user-avatar">A</div>
      <div className="user-info">
        <div className="user-name">Alex Morgan</div>
        <div className="user-country">United Kingdom</div>
      </div>
    </div>
  </div>

  {/* REVIEW 2 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Perfect for travelers with limited time. In just a few hours, we saw
      Everest up close without any physical effort.
    </div>

    <div className="review-user">
      <div className="user-avatar">S</div>
      <div className="user-info">
        <div className="user-name">Sophia Lee</div>
        <div className="user-country">Singapore</div>
      </div>
    </div>
  </div>

  {/* REVIEW 3 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Highly recommended! Stunning mountain views, professional crew, and
      an unforgettable helicopter flight over the Himalayas.
    </div>

    <div className="review-user">
      <div className="user-avatar">R</div>
      <div className="user-info">
        <div className="user-name">Rahul Verma</div>
        <div className="user-country">India</div>
      </div>
    </div>
  </div>

</div>
</div>
</div>
<div className="cta-section">

<div className="cta-button book" onClick={()=>seT(true)}>
  <FontAwesomeIcon icon={faCalendarCheck} />
  <div className="cta-text">Book Now</div>
</div>

<div className="cta-button customize" onClick={()=>seTe(true)}>
  <FontAwesomeIcon icon={faSliders} />
  <div className="cta-text">Customize</div>
</div>

<div className="cta-button review" onClick={()=>seTr(true)}>
  <FontAwesomeIcon icon={faStar} />
  <div className="cta-text">Review</div>
</div>

</div>
    </div>
    <section id='price'>
    <div className='Right'>
        <div className="in-right">
         <div className="out-right">
            <div className="out-in-right"> 
            <h3>Starting Price</h3>
            <div className="price-tag">
              <div className="icon-price-tag">
               <FontAwesomeIcon icon={faTag} className='icon'/>
              </div>
              <div className="icon-details">
                 <div className="right-price">
                  <p>$5850</p>
                  <p className="per-person">/Per Person</p>
                 </div>
                 <p className='little'>All Price Inclusive</p>
            </div>
            </div>
            </div>
            <div className="number-of-traveller">
              <p>Number Of Travellers</p>
              <p className='lt'><FontAwesomeIcon icon={faBolt}></FontAwesomeIcon>Price Decreases When Travellers Increases</p>
              <div className="people-box">
              <FontAwesomeIcon icon={faMinus} className='people-box-icon'onClick={()=>{if(count>1){Setcount(count-1)}}}/>
                <p className='count'>{count}</p>
                <FontAwesomeIcon icon={faPlus} className='people-box-icon'onClick={()=>{Setcount(count+1)}}/>
              </div>
              <div className='Total-Amount'>
                <p className='total-price'>Total Amount</p>
                <p>${totalprice}</p>
              </div>
              <div className="booking-button">
                <Link to="/Terms" className="download">
                 
                  <h6>See Terms & Condition</h6>
                </Link>
                <div className="booking-btn">
                  <button onClick={()=>seT(true)}>Book Now</button>
                  <button onClick={()=>seTe(true)}>Enquiry Now</button>
                </div>
              </div>
            </div>
         </div>
         </div>
         <div className="tour-rep-section">
      <h2 className="section-heading">Trip Expert</h2>
      
       <div className="rep-card">
        <div className="image-container">
          <img 
            src="/img/company/destination expert.png" 
            alt="Sales Manager" 
            className="rep-image" 
          />
        </div>
        
        <div className="rep-info">
          <h3 className="rep-name">Bishnu Pandey</h3>
           <div className="contact-item">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <a href="mailto:sales@yourtravelco.com">012shy1234@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
        </div>
        </section>
   </div>
     <h2 className="hws">Similar Packages</h2>
     <PackageSlider packages={packages} />
     <section className='sticky-bott'>
     <div className="booking-btn">
      <button onClick={()=>seT(true)}>Book Now</button>
      <button onClick={()=>seTe(true)}>Enquiry Now</button>
      </div>
     </section>
     {opent &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seT(false)}
    >
      Back
      
    </div>
   <Bookingform src="/img/pokhara/pokhara1dslr.jpeg" title="Nepal's Golden Triangle"/></section>)}
{opente &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/pokhara/pokharadslr.jpeg" title="Everest For Seniors"/></section> )}
{openr &&(  <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/pokhara/pokharadslr.jpeg" title="Everest For Seniors"/></section>)}
   </main>
  )
}
export default Senioreve